export enum OTPVerificationNavigationEvents {
	CANCEL,
	CONTINUE,
}
